import { Site } from "@equiem/web-ng-lib";
import { useContext, useEffect, useState } from "react";
import { useChatBotIsEnabledForViewerQuery } from "../generated/ai-client";

// This should be just Equiem staff!.
const whitelistEmails = [
  "jeremy.kirkham@equiem.com.au",
  "ryan.ghanbari@getequiem.com",
  "rinita.sur@getequiem.com",
  "jen.leibhart@getequiem.com",
  "faraz.ahmad@getequiem.com",
  "paul.heasley@getequiem.com",
  "julia.bearzatto@getequiem.com",
  "gabrielle.mcmillan@getequiem.com",
  "sarah.machon@getequiem.com",
  "katy.austin@getequiem.com",
  "james.harvey@getequiem.com",
  "eranga.manchanayake@equiem.com.au",
  "arkadiusz.klyk@getequiem.com",
];

export const useShowAi = (email?: string) => {
  const emailIsWhitelisted =
    email != null ? whitelistEmails.map((e) => e.toLowerCase()).includes(email.toLowerCase()) : false;

  const [show, setShow] = useState(emailIsWhitelisted);
  const { uuid } = useContext(Site);
  const { data } = useChatBotIsEnabledForViewerQuery({
    variables: {
      siteUuid: uuid,
    },
  });

  useEffect(() => {
    if (data != null) {
      setShow(emailIsWhitelisted || data.destination.chatBotIsEnabledForViewer);
    }
  }, [data, emailIsWhitelisted]);

  return show;
};
